import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { StepTask } from '@telespot/domain';

export interface Step {
  id: string;
  stepTask: StepTask;
  pipelineId: string;
  generateFinding: string; // TODO: define
  trigger: string; // TODO: define
  order: number;
  executorId: string;
  thresholds: Record<string, number>;
  allowNewOptions: boolean;
  enableMosaicView: boolean;
  counter: number;
  categories: string[];
  multiple: boolean;
}

export interface CategorizationItem {
  id: string;
  stepId: string;
  options: string[];
}

export interface StepsState extends EntityState<Step> {
  pipelineCategories: Record<string, string[]>;
  pipelineSteps: Record<string, string[]>;
  categories: Record<string, CategorizationItem>;
  loading: boolean;
  error: string | undefined;
}

export const stepAdapter = createEntityAdapter<Step>();
